/*
 * Purpose: Analytics cookie consent — GDPR-style opt-in storage
 * Last modified: 2026-06-28 | Agent
 * Completeness: 94
 */
const STORAGE_KEY = 'autoblocks:analytics-consent';
const ANON_KEY = 'autoblocks:analytics-anon-id';

export type AnalyticsConsent = 'accepted' | 'declined' | 'unset';

export function getAnalyticsConsent(): AnalyticsConsent {
  if (typeof window === 'undefined') return 'unset';
  const v = localStorage.getItem(STORAGE_KEY);
  if (v === 'accepted' || v === 'declined') return v;
  return 'unset';
}

export function setAnalyticsConsent(value: 'accepted' | 'declined'): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, value);
}

export function hasAnalyticsConsent(): boolean {
  return getAnalyticsConsent() === 'accepted';
}

export function getAnonymousId(): string {
  if (typeof window === 'undefined') return 'server';
  let id = localStorage.getItem(ANON_KEY);
  if (!id) {
    id = `anon-${Math.random().toString(36).slice(2, 11)}`;
    localStorage.setItem(ANON_KEY, id);
  }
  return id;
}
